import { render } from "./EmailSaas.vue?vue&type=template&id=314c53d8"
import script from "./EmailSaas.vue?vue&type=script&lang=js"
export * from "./EmailSaas.vue?vue&type=script&lang=js"

import "./EmailSaas.vue?vue&type=style&index=0&id=314c53d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__